import React, { useState, useEffect } from "react";
import axios from "axios";
import { url } from "../../Constant";
import { useAuth } from "../../Context/AuthProvider";
import ReactPaginate from "react-paginate";
import FilterModal from "../../components/Modal/FilterModal";
import {
  checkIndividualPermission,
  checkPermissions,
} from "../../Utils/PermissionFunctions";
import FilterDateModal from "../../components/Modal/FilterDateModal";
import { useNavigate } from "react-router-dom";

const NewFeedback = () => {
  const navigate = useNavigate();
  const [size, setSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [incomingData, setIncomingData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [apicalled, setApiCalled] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [dateError, setDateError] = useState("");
  const [error, setError] = useState("");
  const [filterData, setFilterData] = useState({
    start_date: null,
    end_date: null,
  });
  const { auth } = useAuth();

  useEffect(() => {
    if (apicalled === true) {
      getFeedback(1);
    }
  }, [apicalled]);
  useEffect(() => {
    setLoader(true);
    getFeedback(currentPage);
  }, [size]);

  const handleOpenFilterModal = () => {
    setOpenFilterModal(true);
  };
  const handleCloseFilterModal = () => {
    setOpenFilterModal(false);
  };

  const getFeedback = (page) => {
    axios
      .post(
        url + "feedback-cdrs",
        {
          vpbx_id: auth.vpbx_id,
          page: page,
          start_date: filterData.start_date,
          end_date: filterData.end_date,
          clientNumber: filterData.clientNumber,
          campaignName: filterData.campaignName,
          limit: size,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            setLoader(false);
            setApiCalled(false);
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setIncomingData([]);
            } else if (response.data.message === "Data Found") {
              setIncomingData(response.data.data.feedback_cdrs);
              setPageCount(response.data.data.pages);
            }
            handleCloseFilterModal();
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };

  const filteredData = incomingData?.filter((val) => {
    return (
      (val.caller_id &&
        typeof val.caller_id === "string" &&
        val.caller_id.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.order_no &&
        typeof val.order_no === "string" &&
        val.order_no.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.campaign_name &&
        typeof val.campaign_name === "string" &&
        val.campaign_name.toLowerCase().includes(searchText.toLowerCase()))
    );
  });

  const handleExportData = () => {
    // setLoader(true);
    setDownloadLoader(true);
    axios
      .post(
        url + "feedback-download-cdrs",
        {
          vpbx_id: auth.vpbx_id,
          start_date: filterData.start_date,
          end_date: filterData.end_date,
          limit: size,
          clientNumber: filterData.clientNumber,
          campaignName: filterData.campaignName,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            setDownloadLoader(false);
            window.location.href = response.data.data;
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const handlePageChange = (data) => {
    setLoader(true);
    getFeedback(data.selected + 1);
    setCurrentPage(data.selected + 1);
  };

  return (
    // <div className="dashboardWrp">
    //   <div className="uk-container uk-container-large">
    //     <div className="dashboardTop">
    //       <div uk-grid="" className="uk-grid uk-grid-small">
    //         <div className="uk-width-2-3">
    //           <div className="dashboardIntro">
    //             <h3>CALL RECORDS</h3>
    //             {auth.role === "2" && (
    //               <p>
    //                 Use this page to view the call logs or call history,
    //                 including inbound, outbound, and missed calls.
    //               </p>
    //             )}
    //           </div>
    //         </div>

    //         <div className="uk-width-1-1 ">
    //           <ul
    //             className="uk-subnav callSwitcher"
    //             uk-switcher="connect: .callClass"
    //           >
    //             {(auth.role === "2" || auth.role === "3") && (
    //               <>
    //                 {auth.role === "2" || checkPermissions("incoming-calls") ? (
    //                   <li onClick={() => navigate("/incoming-calls")}>
    //                     <a href="#">Incoming calls</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.role === "2" || checkPermissions("outgoing-calls") ? (
    //                   <li onClick={() => navigate("/outgoing-calls")}>
    //                     <a href="#">Outgoing calls</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.role === "2" || checkPermissions("offtime-calls") ? (
    //                   <li onClick={() => navigate("/missed-calls")}>
    //                     <a href="#">Offtime calls</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.role === "2" ||
    //                 checkPermissions("ext-to-ext-calls") ? (
    //                   <li onClick={() => navigate("/ext-to-ext")}>
    //                     <a href="#">Ext. to Ext.</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.call_initiated === "1" ? (
    //                   <li
    //                     className="uk-active"
    //                     onClick={() => navigate("/feedback")}
    //                   >
    //                     <a href="#">Feedback</a>
    //                   </li>
    //                 ) : null}
    //               </>
    //             )}
    //           </ul>
    //         </div>
    //       </div>
    //       <ul className="uk-switcher uk-margin callClass">
    //         {(auth.role === "2" || auth.role === "3") && (
    //           <>
    //             {auth.role === "2" || checkPermissions("incoming-calls") ? (
    //               <li></li>
    //             ) : null}
    //             {auth.role === "2" || checkPermissions("outgoing-calls") ? (
    //               <li></li>
    //             ) : null}
    //             {auth.role === "2" || checkPermissions("offtime-calls") ? (
    //               <li></li>
    //             ) : null}
    //             {auth.role === "2" || checkPermissions("ext-to-ext-calls") ? (
    //               <li></li>
    //             ) : null}
    //             {auth.call_initiated === "1" ? (
    //               <li>
    <div className="ImcomingCallMain">
      <div className="uk-grid" uk-grid="">
        <div className="uk-width-1-2">
          <div className="uk-text-left">
            <div className="CustomSearch">
              <form className="uk-search uk-search-default">
                <input
                  className="uk-search-input"
                  type="text"
                  placeholder="Search by all field"
                  value={searchText}
                  onChange={handleSearch}
                />
              </form>
            </div>
          </div>
        </div>

        <div className="uk-width-1-2">
          <div className="uk-text-right">
            <span>
              <div className="uk-inline uk-text-left">
                {(auth.role === "2" ||
                  checkIndividualPermission(
                    "incoming-calls",
                    "read_and_write"
                  )) && (
                  <>
                    <button
                      className="exportData-button"
                      onClick={handleOpenFilterModal}
                    >
                      Add Filter
                    </button>
                    <button
                      className="exportData-button"
                      onClick={handleExportData}
                    >
                      {downloadLoader ? (
                        <div uk-spinner=""></div>
                      ) : (
                        "Export Data"
                      )}
                    </button>
                  </>
                )}
              </div>
            </span>
          </div>
        </div>
      </div>

      <div>
        {loader ? (
          <div uk-spinner="" className="tableloader"></div>
        ) : filteredData.length === 0 ? (
          <div className="customtableNoDataText">
            There are no records to display
          </div>
        ) : (
          <div className="customTable">
            <table>
              <thead>
                <tr>
                  <th>Campaign Name</th>
                  <th>Campaign ID</th>
                  <th>Client</th>
                  <th>Agent</th>
                  <th>Duration</th>
                  {process.env.REACT_APP_TCS_VPBX === auth.vpbx_id && (
                    <th>Tracker Id</th>
                  )}
                  <th>Date Time</th>
                  <th>Status</th>
                  <th>Feedback</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((val, index) => (
                  <>
                    <tr key={index}>
                      <td>{val.campaign_name}</td>
                      <td>{val.campaign_id}</td>
                      <td>{val.caller_id}</td>
                      <td>{val.order_no}</td>
                      <td>{val.call_duration}</td>
                      {process.env.REACT_APP_TCS_VPBX === auth.vpbx_id && (
                        <td>{val.tracking_id}</td>
                      )}
                      <td>{val.outbound_call_time}</td>
                      <td>{val.response}</td>
                      <td>{val.input}</td>
                    </tr>
                    <br />
                  </>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="tablePaginationBox ">
          <div className="uk-margin-left">
            Show{" "}
            <select onChange={(e) => setSize(e.target.value)}>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>{" "}
            entries
          </div>
          <div>
            {pageCount > 0 && (
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                breakLabel={"...."}
                pageCount={pageCount}
                onPageChange={handlePageChange}
                containerClassName={
                  "uk-pagination uk-float-right contatPagination"
                }
                activeClassName={"uk-active"}
                marginPagesDisplayed={3}
                pageRangeDisplayed={6}
              />
            )}
          </div>
        </div>
      </div>
      {openFilterModal && (
        <FilterDateModal
          closeModal={handleCloseFilterModal}
          setFilterData={setFilterData}
          filterData={filterData}
          setApiCalled={setApiCalled}
          getFilterData={getFeedback}
          setDateError={setDateError}
          dateError={dateError}
          error={error}
          setError={setError}
        />
      )}
    </div>
    //               </li>
    //             ) : null}
    //           </>
    //         )}
    //       </ul>
    //     </div>
    //   </div>
    // </div>
  );
};

export default NewFeedback;
